import React from 'react';

import User from '../../Assets/Icons/User.svg'
import Loc from '../../Assets/Icons/Loc.svg'
import TicketStitch from '../../Assets/decals/TicketStitch.svg'
import CutoutTop from '../../Assets/decals/CutoutTop.svg'
import CutoutBottom from '../../Assets/decals/CutoutBottom.svg'
import Btn from '../Common/Btn';
import '../../Pages/Ticket.css'

const ContetCardRight = (props) => {

    const isBooked = props.bookingData && props.bookingData.length > 0;

    return ( 
        <section className='ContentCardRight'>
                        <div className='TicketCard'>
                            <img className='CutoutTop' src={CutoutTop} alt="" />
                            <img className='CutoutBottom' src={CutoutBottom} alt="" />


                            <img className='TicketStitch' src={TicketStitch} alt="" />

                            {!isBooked && (
                                <p className='TempText'>
                                    {props.TempText}
                                </p>
                            )}

                            {isBooked && (
                                <div className='TicketInfo'>
                                    <div className='UserInfo'>
                                        <p className='InfoTitle'>
                                            <img className='InfoTitle' src={User} alt="" />
                                            Attendee
                                        </p>
                                        <p className='InfoValue'>
                                            {props.bookingData[0].users?.first_name} {props.bookingData[0].users?.last_name}
                                        </p>
                                    </div>

                                    <div className='UserInfo'>
                                        <p className='InfoTitle'>Ticket No.</p>
                                        <p className='InfoValue'>
                                            #EV-{props.bookingData[0].id.slice(0, 5)}
                                        </p>
                                    </div>

                                    <div className='UserInfo'>
                                        <p className='InfoTitle'>
                                            <img className='InfoTitle' src={Loc} alt="" />
                                            Location
                                        </p>
                                        <p className='InfoValue'>
                                            Cairo International Convention Centre, HALL 4
                                        </p>
                                    </div>
                                </div>
                            )}



                            <Btn 
                                BtnStyle='RightBtn' 
                                BtnText={isBooked ? 'View' : 'Register'} 
                                LinkClass='BookLink' 
                                BtnPath={isBooked ? '/ticket' : '/register'}
                            />
                        </div>
                    </section>
     );
}
 
export default ContetCardRight;